(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spatialx-seam-request"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';
    if (window.SpatialxSeamRequest) return;
    const root = document.querySelector('[data-seam-request-root]');
    if (!root) return;
    const dialog = root.querySelector('[data-seam-request-dialog]');
    const host = root.querySelector('[data-seam-request-form-host]');
    const loading = root.querySelector('[data-seam-request-loading]');
    const unavailable = root.querySelector('[data-seam-request-unavailable]');
    const observed = new WeakSet();
    let timer = null;
    let poll = null;
    let restoreTarget = null;
    let stoppedLenis = null;
    let formReady = false;

    function stopWaiting() {
      window.clearTimeout(timer);
      window.clearInterval(poll);
      timer = null;
      poll = null;
    }

    function inspectState(scope) {
      const step = scope.querySelector('[data-current-step]');
      if (!step) return;
      const current = step.getAttribute('data-current-step');
      // Observe Shopify's rendered state only. Never infer delivery or alter its form.
      if ((current === 'form' && scope.querySelector('form')) || current === 'success' || current === 'error') {
        formReady = true;
        loading.hidden = true;
        unavailable.hidden = true;
        root.dataset.formState = current;
        stopWaiting();
      }
    }

    function inspectHost() {
      inspectState(host);
      host.querySelectorAll('shopify-forms-embed, form-embed').forEach((embed) => {
        const shadow = embed.shadowRoot;
        if (!shadow) return;
        if (!observed.has(shadow)) {
          observed.add(shadow);
          new MutationObserver(() => inspectState(shadow)).observe(shadow, {
            childList: true, subtree: true, attributes: true,
            attributeFilter: ['data-current-step'], characterData: true
          });
        }
        inspectState(shadow);
      });
    }

    function waitForForm() {
      inspectHost();
      if (formReady || timer) return;
      loading.hidden = false;
      unavailable.hidden = true;
      poll = window.setInterval(inspectHost, 400);
      timer = window.setTimeout(() => {
        stopWaiting();
        inspectHost();
        if (formReady) return;
        loading.hidden = true;
        unavailable.hidden = false;
        root.dataset.formState = 'unavailable';
      }, 15000);
    }

    function afterClose() {
      document.documentElement.classList.remove('seam-request-open');
      if (stoppedLenis && window.sxLenis === stoppedLenis &&
        !document.documentElement.classList.contains('sx-nav-pending') &&
        !document.documentElement.classList.contains('sx-router-swapping')) {
        try { stoppedLenis.start(); } catch (error) { /* Router may have replaced its scroll instance. */ }
      }
      stoppedLenis = null;
      if (restoreTarget && restoreTarget.isConnected) restoreTarget.focus({ preventScroll: true });
      restoreTarget = null;
    }

    function open(trigger) {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      if (!dialog.open) {
        restoreTarget = trigger || document.activeElement;
        try { dialog.showModal(); } catch (error) { return false; }
        document.documentElement.classList.add('seam-request-open');
        if (window.sxLenis && window.sxLenis.isStopped === false) {
          stoppedLenis = window.sxLenis;
          try { stoppedLenis.stop(); } catch (error) { stoppedLenis = null; }
        }
      }
      waitForForm();
      return true;
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest && event.target.closest('a[data-seam-request]');
      if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (trigger.target && trigger.target !== '_self') return;
      if (open(trigger)) event.preventDefault();
    }, true);

    if (dialog) {
      root.querySelector('[data-seam-request-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', afterClose);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      // Native cancel handles Escape; leaving the page must not focus its old trigger.
      const closeOnNavigation = () => {
        restoreTarget = null;
        if (dialog.open) dialog.close();
      };
      window.addEventListener('sx:router:navigate', closeOnNavigation);
      window.addEventListener('popstate', closeOnNavigation);
    }

    root.querySelector('[data-seam-request-retry]').addEventListener('click', () => {
      if (root.dataset.mode === 'page') window.location.reload();
      else window.location.assign(root.dataset.fallbackUrl);
    });
    new MutationObserver(inspectHost).observe(host, { childList: true, subtree: true });
    if (window.customElements) {
      ['shopify-forms-embed', 'form-embed'].forEach((name) => customElements.whenDefined(name).then(inspectHost));
    }
    window.SpatialxSeamRequest = { open };
    waitForForm();
  })();
  } catch(e) { console.error(e); }
})();

})();
